import React from 'react'
let vector = ['1'];
let total = 0,price = 0, total_d = 0;
let validate_brand_select = 1;
let validate_category_select = 1;
let countLine = 1,countBrand=1,countCategory = 1;

const List = function list ({text,products,prev,next,linesT,categoriesT,brandsT}){
    let cont = 0,page=1,pageNext = 0;
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                    <img src={https+"img/back.svg"} alt="⬅"/>
                    <span>Atrás</span>
                </a>
            </div>
        
            <div className="bannerShop w90 dnone">
                <img src={https+text.img} alt="bannerShop"/>
                <h6 className='h6_title_search'>
                    Buscando: {name_search}
                </h6>  
            </div>
        
            <section className="shop">
            <div className="container w90">

                <div className="listProducts listSearch grid">
                    {vector.map((v) => {
                        if (products.length > 1) {
                            setTimeout(function (){
                                $('.pages').hide();
                                $('.page_1').show();
                            },100);
                        }
                    })}
                    {vector.map((v) => {
                        if(products.length <= 0){
                            return <div key={v} className="not_products column total colflex" style={{
                                textAlign:`center`,
                                margin:`0%`,
                                width: `100%`,
                                display: `none`
                            }}>
                                <h4>
                                    No hay productos
                                </h4>
                            </div>
                        }
                    })}
                    {vector.map((v) => {
                        if(products.length <= 0){
                            return <div key={v} className="loading column total colflex" style={{
                                textAlign:`center`,
                                margin:`0%`,
                                width: `100%`
                            }}>
                                <h4>
                                    Cargando . . .
                                </h4>
                            </div>
                        }
                    })}
                    
                    {products.map((p)=> {
                        if (cont >= 8) {
                            pageNext = 2;
                            page++
                            cont = 0;
                        }
                        cont++
                        countLine = 1;
                        if(p.descount > 0){
                            total = new Intl.NumberFormat().format(p.price);
                            total = total.replace(/,/g , ".");
                            price = (p.price - (p.price * p.descount / 100));
                            total_d = new Intl.NumberFormat().format(price);
                            total_d = total_d.replace(/,/g , ".");
                            return(
                                <a href={https+'product/'+p.id} 
                                className={'product colflex pages page_'+ page} key={p.id}
                                >
                                    <div className="img">
                                        <div>
                                            <img src={https+p.img} alt="item"/>
                                        </div>
                                    </div>
                                    <p>{p.name}</p>
                                    {brandsT.map((b)=>
                                    {
                                        if(b.id == p.brand_id){
                                            countBrand = 2;
                                            return <p className='p_2'>{b.name}</p>
                                        }
                                    }
                                    )}
                                    {vector.map((v) => {
                                        if(countBrand == 1){
                                            return <p className='p_2'>&nbsp;</p>
                                        }
                                    }
                                    )}
                                    {categoriesT.map((c)=>
                                    {
                                        if(c.id == p.category_id){
                                            countCategory = 2;
                                            return <p className='p_2'>{c.name}</p>
                                        }
                                    }
                                    )}
                                    {vector.map((v) => {
                                        if(countCategory == 1){
                                            return <p className='p_2'>&nbsp;</p>
                                        }
                                    }
                                    )}
                                    {linesT.map((l)=>
                                        {
                                            if(l.id == p.line_id){
                                                countLine = 2;
                                                return <p className='p_2'>{l.name}</p>
                                            }
                                        }
                                    )}
                                    {vector.map((v) => {
                                        if(countLine == 1){
                                            return <p className='p_2'>&nbsp;</p>
                                        }
                                    }
                                    )}
                                    <span className="price">${total}</span>
                                    <div className="flex">
                                        <h4 className="offer">${total_d}</h4>
                                        <h5 className="discount">
                                            {p.descount}% OFF
                                        </h5>
                                    </div>
                                </a>
                            )
                        }else{
                            total = new Intl.NumberFormat().format(p.price);
                            total = total.replace(/,/g , ".");
                            return (
                                <a href={https+'product/'+p.id} 
                                className={'product colflex pages page_'+ page} key={p.id}
                                >
                                    <div className="img">
                                        <div>
                                            <img src={https+p.img} alt="item"/>
                                        </div>
                                    </div>
                                    <p>{p.name}</p>
                                    {brandsT.map((b)=>
                                    {
                                        if(b.id == p.brand_id){
                                            countBrand = 2;
                                            return <p className='p_2'>{b.name}</p>
                                        }
                                    }
                                    )}
                                    {vector.map((v) => {
                                        if(countBrand == 1){
                                            return <p className='p_2'>&nbsp;</p>
                                        }
                                    }
                                    )}
                                    {categoriesT.map((c)=>
                                    {
                                        if(c.id == p.category_id){
                                            countCategory = 2;
                                            return <p className='p_2'>{c.name}</p>
                                        }
                                    }
                                    )}
                                    {vector.map((v) => {
                                        if(countCategory == 1){
                                            return <p className='p_2'>&nbsp;</p>
                                        }
                                    }
                                    )}
                                    {linesT.map((l)=>
                                        {
                                            if(l.id == p.line_id){
                                                countLine = 2;
                                                return <p className='p_2'>{l.name}</p>
                                            }
                                        }
                                    )}
                                    {vector.map((v) => {
                                        if(countLine == 1){
                                            return <p className='p_2'>&nbsp;</p>
                                        }
                                    }
                                    )}
                                    <span className="price">&nbsp;</span>
                                    <div className="flex">
                                        <h4 className="offer">${total}</h4>
                                        <h5 className="discount"></h5>
                                    </div>
                                </a>
                            )
                        }
                    })}

                </div>

                <div className="pagination grid">
                    <div className='flex'></div> 
                    {vector.map((v) => {
                        if (pageNext > 0) {
                            return <div className="flex"
                                        id={0} key={v}
                                    >
                                        <a className="pagePrev" id="0" onClick={prev}>
                                            <span>Pagina Anterior</span>
                                        </a>
                                    </div>
                        }
                    })}
                    {vector.map((v) => {
                        if (pageNext > 0) {
                            return <div className="flex"
                                        key={v}
                                    >
                                        <a className="pageNext" id={pageNext} onClick={next}>
                                            <span>Pagina Siguiente</span>
                                        </a>
                                    </div>
                        }
                    })}
                </div> 
        
            </div>
            </section>
        </main>
)
}

export default List
